import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	reportingLinesEmptyStateContainer: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'space-around',
		width: '100%',
		paddingTop: token('space.600'),
		paddingRight: token('space.250'),
		paddingBottom: token('space.600'),
		paddingLeft: token('space.250'),
	},
	reportingLinesEmptyStateContent: {
		marginTop: token('space.150'),
		marginBottom: token('space.150'),
	},
	reportingLinesEmptyStateImage: {
		marginTop: token('space.150'),
		marginBottom: token('space.150'),
	},
	reportingLinesEmptyStateHeading: {
		font: token('font.heading.medium'),
	},
	infoMessage: {
		marginBottom: token('space.250'),
	},
});

export const ReportingLinesEmptyStateContainer = ({
	children,
	testId,
}: {
	children: React.ReactNode;
	testId?: string;
}): React.JSX.Element => {
	return (
		<Box xcss={styles.reportingLinesEmptyStateContainer} testId={testId}>
			{children}
		</Box>
	);
};

export const ContentSection = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
	return <Box xcss={styles.reportingLinesEmptyStateContent}>{children}</Box>;
};

export const InfoMessage = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
	return <Box xcss={styles.infoMessage}>{children}</Box>;
};
